<template>
  <span>
    <v-btn
      v-if="business && plan && DAYS_LEFT <= 10"
      class="pl-1"
      color="amber lighten-5 amber--text"
      depressed
      large
      id="subscriptionAlertButton"
      rounded
      @click="
        showDetails = true;
        getPlans();
        getPlanDetails();
      "
    >
      <span
        class="pa-1 ml-0"
        style="background-color: white !important; border-radius: 50%"
      >
        <v-progress-circular
          :value="progressValue"
          color="amber darken-3"
          width="2"
        >
          <small class="text-small text-center" style="font-size: 7px">
            {{ DAYS_LEFT }}<br />
            Days
          </small>
        </v-progress-circular>
      </span>
      <span v-if="!$vuetify.breakpoint.mobile">
        To Expire <v-icon class="bell" large>mdi-bell-outline</v-icon>
      </span>
    </v-btn>
    <v-dialog v-model="showDetails" width="500px">
      <v-card
        :class="{
          'amber lighten-5': !$vuetify.theme.isDark,
          black: $vuetify.theme.isDark,
        }"
        flat
        style="border-radius: 25px"
      >
        <v-card-title>
          <v-btn v-if="step > 1" text @click="step = 1" rounded
            ><v-icon>mdi-arrow-left</v-icon>Back</v-btn
          >

          <v-spacer></v-spacer>
          <v-btn
            color="amber"
            depressed
            outlined
            rounded
            @click="
              showDetails = false;
              step = 1;
            "
            >close<v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text class="text-center">
          <v-stepper elevation="0" class="rounded-xl" v-model="step">
            <v-stepper-content step="1">
              <v-icon class="bell" color="amber" x-large
                >mdi-bell-outline</v-icon
              >

              <h1 class="font-weight-light display-1 amber--text">
                {{ DAYS_LEFT }} Days Left
              </h1>
              <p>
                Your subscription will expire in
                <strong> {{ DAYS_LEFT }} days</strong> , this is a reminder to
                prepare for renewal of your subscription when it expires.
              </p>

              <v-list
                class="text-left"
                style="border-radius: 15px; opacity: 0.7"
                v-if="plan"
              >
                <v-list-item class="border-bottom">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">{{
                      plan.planname
                    }}</v-list-item-title>
                    <v-list-item-subtitle class="text-small"
                      >Plan Name</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="border-bottom">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">{{
                      plan.start_date | humanDate
                    }}</v-list-item-title>
                    <v-list-item-subtitle class="text-small"
                      >Start Date</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="border-bottom">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">{{
                      plan.end_date | humanDate
                    }}</v-list-item-title>
                    <v-list-item-subtitle class="text-small"
                      >End Date</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="border-bottom">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">{{
                      extensionCurrencyPrefix
                    }}{{ plan.amount | toMoney }}</v-list-item-title>
                    <v-list-item-subtitle class="text-small"
                      >Amount</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="border-bottom">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                      <!--              <v-btn-->
                      <!--                  color="green"-->
                      <!--                  dark-->
                      <!--                  x-large-->
                      <!--                  rounded-->
                      <!--                  depressed-->
                      <!--                  block-->
                      <!--                  @click="step=2"-->
                      <!--              >Extend Subscription<v-icon dark>mdi-arrow-right</v-icon></v-btn>-->
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="mt-2">
                  <v-btn
                    @click="step = 2"
                    depressed
                    color="green"
                    rounded
                    x-large
                    block
                    dark
                    >Extend subscription
                    <v-icon small dark>mdi-plus</v-icon></v-btn
                  >
                </v-list-item>

                <v-list-item class="mt-3" @click="step = 3">
                  <v-btn depressed color="green" text rounded x-large block dark
                    >Change Plan<v-icon dark small>mdi-reload</v-icon></v-btn
                  >
                </v-list-item>
              </v-list>
            </v-stepper-content>

            <v-stepper-content step="2">
              <h2>
                Current Plan:<strong> {{ plan.planname }}</strong>
              </h2>

              <v-timeline dense clipped>
                <v-timeline-item color="grey" small left class="text-left pa-0">
                  <v-list-item dense class="pa-0 ma-0">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-black">
                        {{ extensionCurrencyPrefix }}{{ plan.amount | toMoney }}
                      </v-list-item-title>
                      <v-list-item-subtitle> Amount Paid </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-timeline-item>

                <v-timeline-item color="grey" small left class="text-left pa-0">
                  <v-list-item dense class="pa-0 ma-0">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-black">
                        {{ plan.start_date | humanDate }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        Started Date
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-timeline-item>

                <v-timeline-item color="grey" small left class="text-left pa-0">
                  <v-list-item dense class="pa-0 ma-0">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-black">
                        {{ plan.end_date | humanDate }}
                      </v-list-item-title>
                      <v-list-item-subtitle> End Date </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-timeline-item>

                <v-timeline-item hide-dot small left class="text-left pa-0">
                  <h2>Extend Subscription</h2>
                </v-timeline-item>

                <v-timeline-item
                  color="green"
                  small
                  left
                  class="text-left pa-0"
                >
                  <v-list-item dense class="pa-0 ma-0">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-black">
                        {{ extensionStartDate | humanDate }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        Extension Start Date
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-timeline-item>

                <v-timeline-item
                  color="green"
                  small
                  left
                  class="text-left pa-0"
                >
                  <v-list-item dense class="pa-0 ma-0">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-black">
                        {{ extensionEndDate | humanDate }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        Extension End Date
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-timeline-item>

                <v-timeline-item
                  color="green"
                  small
                  left
                  class="text-left pa-0"
                >
                  <v-list-item dense class="pa-0 ma-0">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-black">
                        {{ cycle }} Months
                      </v-list-item-title>
                      <v-list-item-subtitle> Cycle </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-timeline-item>
              </v-timeline>

              <v-sheet
                v-if="planDetails"
                color="grey lighten-5"
                rounded="lg"
                elevation="0"
                class="pa-4 mt-4 text-left mx-auto"
                max-width="440"
              >
                <template v-if="isGhanaBusiness && extendCostBreakdown">
                  <div class="d-flex justify-space-between py-2 body-2">
                    <span>Subscription base (before taxes)</span>
                    <strong
                      >{{ extensionCurrencyPrefix
                      }}{{ extendCostBreakdown.base | toMoney }}</strong
                    >
                  </div>
                  <div
                    class="d-flex justify-space-between py-1 text--secondary caption"
                  >
                    <span>VAT (15% of base)</span>
                    <span
                      >{{ extensionCurrencyPrefix
                      }}{{ extendCostBreakdown.vat | toMoney }}</span
                    >
                  </div>
                  <div
                    class="d-flex justify-space-between py-1 text--secondary caption"
                  >
                    <span>NHIL (2.5% of base)</span>
                    <span
                      >{{ extensionCurrencyPrefix
                      }}{{ extendCostBreakdown.nhil | toMoney }}</span
                    >
                  </div>
                  <div
                    class="d-flex justify-space-between py-1 text--secondary caption"
                  >
                    <span>GETFund levy (2.5% of base)</span>
                    <span
                      >{{ extensionCurrencyPrefix
                      }}{{ extendCostBreakdown.getfund | toMoney }}</span
                    >
                  </div>
                  <v-divider class="my-2"></v-divider>
                  <div
                    class="d-flex justify-space-between text-h6 primary--text font-weight-bold"
                  >
                    <span>Total payable</span>
                    <span
                      >{{ extensionCurrencyPrefix
                      }}{{ extendCostBreakdown.total | toMoney }}</span
                    >
                  </div>
                </template>
                <template v-else>
                  <div class="d-flex justify-space-between py-2 body-2">
                    <span>Subscription amount</span>
                    <strong
                      >{{ extensionCurrencyPrefix
                      }}{{ extendSubtotal | toMoney }}</strong
                    >
                  </div>
                  <v-divider class="my-2"></v-divider>
                  <div
                    class="d-flex justify-space-between text-h6 primary--text font-weight-bold"
                  >
                    <span>Total due</span>
                    <span
                      >{{ extensionCurrencyPrefix
                      }}{{ extendChargeAmount | toMoney }}</span
                    >
                  </div>
                </template>
              </v-sheet>

              <v-btn
                x-large
                rounded
                depressed
                block
                color="green"
                class="mt-4 white--text"
                @click="prepareCardPayment('extend')"
                :disabled="!selectedPlan || !cardIntervalIsValid(cycle)"
              >
                Pay With Card
              </v-btn>
              <v-card
                v-if="!isQuarterlyCycle(cycle) || !cardIntervalIsValid(cycle)"
                color="blue-grey lighten-5"
                class="mt-3"
                outlined
                style="border-left: 4px solid #ff9800; border-radius: 8px"
              >
                <v-card-text class="pa-3 text-left">
                  <div class="d-flex align-start">
                    <v-icon small color="orange darken-2" class="mr-2 mt-1"
                      >mdi-information-outline</v-icon
                    >
                    <div
                      v-if="!isQuarterlyCycle(cycle)"
                      class="body-2 grey--text text--darken-1 text-left"
                    >
                      Your current {{ cycle }}-month cycle can no longer be
                      renewed with
                      {{ isGhanaBusiness ? "card or mobile money" : "mobile money" }}.
                      Subscriptions must be 3 months or more, in multiples of
                      3 months.
                      <a href="#" @click.prevent="step = 3">Change plan</a>
                      to pick a new billing cycle.
                    </div>
                    <div v-else class="body-2 grey--text text--darken-1 text-left">
                      Card payments are only available for monthly, quarterly,
                      every 6 months, or annual billing cycles.
                    </div>
                  </div>
                </v-card-text>
              </v-card>

              <v-btn
                @click="momoCheckout = true"
                :disabled="!isQuarterlyCycle(cycle)"
                class="mt-4"
                block
                rounded
                depressed
                color="blue darken-4"
                dark
                x-large
                >Pay With Mobile-Money</v-btn
              >
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-alert
                dense
                color="amber"
                prominent
                text
                type="warning"
                class="text-left black--text"
              >
                <strong>Important</strong>
                <p>
                  If you change a plan or billing cycle here the new plan and
                  it's benefits will start when the current plan ends.
                </p>
              </v-alert>
              <h3 class="mt-2">
                Your new plan will start on {{ extensionStartDate | humanDate }}
              </h3>

              <v-autocomplete
                outlined
                label="Plan"
                :items="plans"
                item-text="name"
                item-value="id"
                v-model="selectedPlan"
                return-object
              ></v-autocomplete>
              <v-autocomplete
                :items="billing_cycles"
                outlined
                v-model="billing_cycle"
                label="Billing Cycle"
              ></v-autocomplete>

              <v-sheet
                v-if="selectedPlan"
                color="grey lighten-5"
                rounded="lg"
                elevation="0"
                class="pa-4 mt-4 text-left mx-auto"
                max-width="440"
              >
                <template v-if="isGhanaBusiness && changeCostBreakdown">
                  <div class="d-flex justify-space-between py-2 body-2">
                    <span>Subscription base (before taxes)</span>
                    <strong
                      >{{ changePlanCurrencyPrefix
                      }}{{ changeCostBreakdown.base | toMoney }}</strong
                    >
                  </div>
                  <div
                    class="d-flex justify-space-between py-1 text--secondary caption"
                  >
                    <span>VAT (15% of base)</span>
                    <span
                      >{{ changePlanCurrencyPrefix
                      }}{{ changeCostBreakdown.vat | toMoney }}</span
                    >
                  </div>
                  <div
                    class="d-flex justify-space-between py-1 text--secondary caption"
                  >
                    <span>NHIL (2.5% of base)</span>
                    <span
                      >{{ changePlanCurrencyPrefix
                      }}{{ changeCostBreakdown.nhil | toMoney }}</span
                    >
                  </div>
                  <div
                    class="d-flex justify-space-between py-1 text--secondary caption"
                  >
                    <span>GETFund levy (2.5% of base)</span>
                    <span
                      >{{ changePlanCurrencyPrefix
                      }}{{ changeCostBreakdown.getfund | toMoney }}</span
                    >
                  </div>
                  <v-divider class="my-2"></v-divider>
                  <div
                    class="d-flex justify-space-between text-h6 primary--text font-weight-bold"
                  >
                    <span>Total payable</span>
                    <span
                      >{{ changePlanCurrencyPrefix
                      }}{{ changeCostBreakdown.total | toMoney }}</span
                    >
                  </div>
                </template>
                <template v-else>
                  <div class="d-flex justify-space-between py-2 body-2">
                    <span>Subscription amount</span>
                    <strong
                      >{{ changePlanCurrencyPrefix
                      }}{{ totalAmount | toMoney }}</strong
                    >
                  </div>
                  <v-divider class="my-2"></v-divider>
                  <div
                    class="d-flex justify-space-between text-h6 primary--text font-weight-bold"
                  >
                    <span>Total due</span>
                    <span
                      >{{ changePlanCurrencyPrefix
                      }}{{ changeChargeAmount | toMoney }}</span
                    >
                  </div>
                </template>
              </v-sheet>

              <v-btn
                x-large
                rounded
                depressed
                block
                color="green"
                class="mt-4 white--text"
                @click="prepareCardPayment('change')"
                :disabled="!selectedPlan || !cardIntervalIsValid(billing_cycle)"
              >
                Pay With Card
              </v-btn>
              <v-card
                v-if="!cardIntervalIsValid(billing_cycle)"
                color="blue-grey lighten-5"
                outlined
                class="mt-3"
                style="border-left: 4px solid #ff9800; border-radius: 8px"
              >
                <v-card-text class="pa-3 text-left">
                  <div class="d-flex align-start">
                    <v-icon small color="orange darken-2" class="mr-2 mt-1"
                      >mdi-information-outline</v-icon
                    >
                    <div class="body-2 grey--text text--darken-1 text-left">
                      Card payments are only available for monthly, quarterly,
                      every 6 months, or annual billing cycles.
                    </div>
                  </div>
                </v-card-text>
              </v-card>
              <v-btn
                x-large
                rounded
                depressed
                block
                dark
                color="blue darken-4"
                class="mt-4"
                @click="momoPlanChangeCheckout = true"
                >Pay With Mobile-Money</v-btn
              >
            </v-stepper-content>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="momoCheckout"
      :fullscreen="$vuetify.breakpoint.mobile"
      persistent
      width="500"
    >
      <v-card>
        <v-card-title class="font-weight-light">
          Pay with
          {{
            ["GH", "RW", "SL"].includes(business.country.code)
              ? "Mobile Money"
              : "Mpesa"
          }}
          <v-spacer></v-spacer>
          <v-btn
            color="red lighten-5 red--text"
            depressed
            rounded
            @click="momoCheckout = false"
            >close
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <checkout
          v-if="plan && plan.planname"
          :account_id="0"
          :amount="extendChargeAmount"
          :cost-breakdown="extendCostBreakdown"
          :discountedPrice="extendChargeAmount"
          :isEligibleForDiscount="false"
          :momo-subscription-coupon="momoSubscriptionCoupon"
          :record_id="cycle"
          :record_type="'subscription-' + plan.planname.toLowerCase()"
          @paymentComplete="send_success"
          extra-prop-key="current_plan_id"
          :extra-prop-value="plan.id"
        ></checkout>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="momoPlanChangeCheckout"
      :fullscreen="$vuetify.breakpoint.mobile"
      persistent
      width="500"
    >
      <v-card>
        <v-card-title class="font-weight-light">
          Pay with
          {{
            ["GH", "RW", "SL"].includes(business.country.code)
              ? "Mobile Money"
              : "Mpesa"
          }}
          <v-spacer></v-spacer>
          <v-btn
            color="red lighten-5 red--text"
            depressed
            rounded
            @click="momoPlanChangeCheckout = false"
            >close
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <checkout
          v-if="selectedPlan && selectedPlan.name"
          :account_id="0"
          :amount="changeChargeAmount"
          :cost-breakdown="changeCostBreakdown"
          :discountedPrice="changeChargeAmount"
          :isEligibleForDiscount="false"
          :momo-subscription-coupon="momoSubscriptionCoupon"
          :record_id="billing_cycle"
          :record_type="'subscription-' + selectedPlan.name.toLowerCase()"
          @paymentComplete="send_success"
          extra-prop-key="change_current_plan_id"
          :extra-prop-value="selectedPlan.id"
        ></checkout>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import moment from "moment";
import Checkout from "@/components/MOMO/Checkout.vue";
import axios from "axios";

const CARD_INTERVALS = [
  {
    months: 1,
    value: "monthly",
    label: "Monthly",
    description: "charged every month",
  },
  {
    months: 3,
    value: "quarterly",
    label: "Quarterly",
    description: "charged every 3 months",
  },
  {
    months: 6,
    value: "six_months",
    label: "Six months",
    description: "charged every 6 months",
  },
  {
    months: 12,
    value: "annually",
    label: "Annually",
    description: "charged once a year",
  },
];

export default {
  name: "subscriptionAlertComponent",
  components: { Checkout },
  data() {
    return {
      showDetails: false,
      momoCheckout: false,
      momoPlanChangeCheckout: false,
      momoSubscriptionCoupon: "",
      plans: [],
      selectedPlan: null,
      plan_id: null,
      step: 1,
      planDetails: null,
      billing_cycle: 3,
      billing_cycles: [
        {
          text: "Every three months",
          value: 3,
        },
        {
          text: "Every six months",
          value: 6,
        },
        {
          text: "Every nine months",
          value: 9,
        },
        {
          text: "Annually",
          value: 12,
        },
        {
          text: "Every two years",
          value: 24,
        },
        {
          text: "Every three years",
          value: 36,
        },
        {
          text: "Every four years",
          value: 48,
        },
      ],
      progress: false,
      interval: "monthly",
    };
  },
  computed: {
    DAYS_LEFT() {
      return Math.floor(this.business.subscription.guards.days_to_expiry);
    },

    isGhanaBusiness() {
      return (
        (this.business?.country?.code || "").toUpperCase() === "GH"
      );
    },

    businessCurrencyPrefix() {
      const c = this.business?.currency;
      if (!c) return "";
      return String(c.code || c.symbol || "").trim();
    },

    /** Prefix for extension / current-plan amounts (falls back to business currency). */
    extensionCurrencyPrefix() {
      const bd = this.planDetails;
      if (bd) {
        if (bd.currency_code != null && String(bd.currency_code).trim() !== "") {
          return String(bd.currency_code).trim();
        }
        const cur = bd.currency;
        if (typeof cur === "string" && cur.trim() !== "") {
          return cur.trim();
        }
        if (cur && typeof cur === "object" && cur.code) {
          return String(cur.code).trim();
        }
      }
      return this.businessCurrencyPrefix;
    },

    /** Prefix for change-plan totals (uses plan list row then business currency). */
    changePlanCurrencyPrefix() {
      const sp = this.selectedPlan;
      const id = sp && sp.id;
      const basePlan =
        id && this.plans.length
          ? this.plans.find((p) => String(p.id) === String(id))
          : null;
      if (basePlan) {
        if (
          basePlan.currency_code != null &&
          String(basePlan.currency_code).trim() !== ""
        ) {
          return String(basePlan.currency_code).trim();
        }
        if (
          basePlan.base_currency_code != null &&
          String(basePlan.base_currency_code).trim() !== ""
        ) {
          return String(basePlan.base_currency_code).trim();
        }
        const cur = basePlan.currency || basePlan.base_currency;
        if (typeof cur === "string" && cur.trim() !== "") {
          return cur.trim();
        }
        if (cur && typeof cur === "object" && cur.code) {
          return String(cur.code).trim();
        }
      }
      if (sp) {
        if (sp.currency_code != null && String(sp.currency_code).trim() !== "") {
          return String(sp.currency_code).trim();
        }
        const raw = sp.base_currency;
        if (typeof raw === "string" && raw.trim() !== "") {
          return raw.trim();
        }
        if (raw && typeof raw === "object" && raw.code) {
          return String(raw.code).trim();
        }
        const c2 = sp.currency;
        if (typeof c2 === "string" && c2.trim() !== "") {
          return c2.trim();
        }
        if (c2 && typeof c2 === "object" && c2.code) {
          return String(c2.code).trim();
        }
      }
      return this.businessCurrencyPrefix;
    },

    totalAmount() {
      if (this.plans.length == 0 || !this.selectedPlan) {
        return 0;
      }

      const basePlan = this.plans.find(
        (plan) => plan.id == this.selectedPlan.id,
      );

      if (!basePlan) {
        return 0;
      }

      return this.roundMoney(basePlan.amount * this.billing_cycle);
    },

    /** Extension (same plan) pre-tax total: API base × current subscription cycle. */
    extendSubtotal() {
      const baseAmount = Number(this.planDetails?.base_amount);
      if (!Number.isFinite(baseAmount)) {
        return 0;
      }
      const c = Number(this.cycle);
      const months = Number.isFinite(c) && c > 0 ? c : 1;
      return this.roundMoney(baseAmount * months);
    },

    /** Shown / charged for extend + MoMo extend (pre-Ghana = extendSubtotal). */
    amountDue() {
      return this.extendSubtotal;
    },

    extendCostBreakdown() {
      return this.buildGhanaCostBreakdown(this.extendSubtotal);
    },

    extendChargeAmount() {
      return this.extendCostBreakdown
        ? this.extendCostBreakdown.total
        : this.extendSubtotal;
    },

    changeCostBreakdown() {
      return this.buildGhanaCostBreakdown(this.totalAmount);
    },

    changeChargeAmount() {
      return this.changeCostBreakdown
        ? this.changeCostBreakdown.total
        : this.totalAmount;
    },

    extensionStartDate() {
      return moment(this.plan.end_date, "Y-MM-DD")
        .add(1, "days")
        .format("Y-MM-DD");
    },
    extensionEndDate() {
      return moment(this.extensionStartDate, "Y-MM-DD")
        .add(this.cycle, "months")
        .format("Y-MM-DD");
    },

    cycle() {
      return this.plan.subscription_cycle;
    },

    currentCycleInterval() {
      return this.cardIntervalEntry(this.cycle);
    },

    selectedBillingInterval() {
      return this.cardIntervalEntry(this.billing_cycle);
    },

    progressValue() {
      return (this.days / 10) * 100;
    },

    user() {
      return this.$store.state.user.user_infor;
    },
    business() {
      return this.user?.current_business;
    },
    plan() {
      return this.business?.subscription.plan;
    },

    days() {
      if (this.business && this.plan) {
        const endDate = moment(this.plan.end_date);

        const today = moment();

        return endDate.diff(today, "days");
      }

      return 0;
    },
  },
  methods: {
    roundMoney(value) {
      return Math.round(Number(value || 0) * 100) / 100;
    },

    buildGhanaCostBreakdown(preTaxSubtotal) {
      if (!this.isGhanaBusiness) {
        return null;
      }
      const b = this.roundMoney(Number(preTaxSubtotal) || 0);
      const vat = this.roundMoney(b * 0.15);
      const nhil = this.roundMoney(b * 0.025);
      const getfund = this.roundMoney(b * 0.025);
      const total = this.roundMoney(b + vat + nhil + getfund);
      return { base: b, vat, nhil, getfund, total };
    },

    cardIntervalEntry(months) {
      return CARD_INTERVALS.find((entry) => entry.months === months);
    },

    intervalFromMonths(months) {
      const entry = this.cardIntervalEntry(months);
      return entry ? entry.value : null;
    },

    isQuarterlyCycle(months) {
      return this.billing_cycles.some((c) => c.value === Number(months));
    },

    cardIntervalIsValid(months) {
      if (this.isGhanaBusiness) return this.isQuarterlyCycle(months);
      return Boolean(this.intervalFromMonths(months));
    },

    prepareCardPayment(mode) {
      const months = mode === "change" ? this.billing_cycle : this.cycle;
      if (!this.cardIntervalIsValid(months)) {
        return;
      }
      this.interval = this.intervalFromMonths(months);
      this.subscribe(mode);
    },

    subscribe(mode) {
      this.progress = true;
      const planName =
        this.selectedPlan?.name ??
        this.selectedPlan?.planname ??
        this.plan?.planname ??
        this.plan?.name;

      if (!planName) {
        this.progress = false;
        return;
      }

      const payload = this.isGhanaBusiness
        ? {
            plan_name: planName,
            interval: mode === "change" ? this.billing_cycle : this.cycle,
            coupon: this.momoSubscriptionCoupon,
            current_plan_id: mode === "change" ? "" : this.plan.id,
            change_current_plan_id:
              mode === "change" ? this.selectedPlan.id : "",
          }
        : {
            plan_name: planName,
            interval: this.interval || "monthly",
            ...(mode === "change"
              ? { change_current_plan_id: this.selectedPlan.id }
              : { current_plan_id: this.plan.id }),
          };
      const url = this.isGhanaBusiness
        ? "/api/paystack/init-subscription"
        : "/api/stripe/init-subscription";
      axios
        .post(url, payload)
        .then((res) => {
          window.open(res.data.url);
          this.progress = false;
        })
        .catch((error) => {
          this.progress = false;
        });
    },

    getPlans() {
      axios
        .get(
          "/api/subscriptionplans/" +
            this.$store.state.user.user_infor.current_business.country.id
        )
        .then((res) => {
          this.plans = res.data;
        });
    },

    getPlanDetails() {
      if (this.plan && this.plan.planname) {
        const URL = "/api/current-plan-details/" + this.plan.planname;
        axios(URL).then((res) => {
          this.planDetails = res.data;
          this.selectedPlan = this.planDetails.plan;
        });
      }
    },
    send_success() {
      alert("done");
    },
  },
  mounted() {
    if (this.isQuarterlyCycle(this.plan.subscription_cycle)) {
      this.billing_cycle = Number(this.plan.subscription_cycle);
    }
    if (this.DAYS_LEFT >= 10) {
      this.getPlanDetails();
    }
  },
};
</script>

<style>
@keyframes bellshake {
  0% {
    transform: rotate(0);
  }
  15% {
    transform: rotate(5deg);
  }
  30% {
    transform: rotate(-5deg);
  }
  45% {
    transform: rotate(4deg);
  }
  60% {
    transform: rotate(-4deg);
  }
  75% {
    transform: rotate(2deg);
  }
  85% {
    transform: rotate(-2deg);
  }
  92% {
    transform: rotate(1deg);
  }
  100% {
    transform: rotate(0);
  }
}

.bell {
  animation: bellshake 0.5s ease-in-out infinite;
  backface-visibility: hidden;
  transform-origin: top right;
}

.v-btn.v-btn--disabled {
  background-color: #e0e0e0 !important;
  color: #9e9e9e !important;
  opacity: 1 !important;
}
</style>
